/**
 * Voice mode for Ask Addy v2, in the browser: speech recognition hears the question, which goes to
 * Lendy like a typed one, and speech synthesis reads the answer back. v2 itself never sees audio.
 */

// Long answers are read up to here; tables, lists past it and the rest stay on screen.
const MAX_SPOKEN_CHARS = 600;

export function getSpeechRecognition() {
  return window.SpeechRecognition || window.webkitSpeechRecognition || null;
}

export function isVoiceSupported() {
  return Boolean(getSpeechRecognition()) && "speechSynthesis" in window;
}

function toSpokenLine(line) {
  return line
    .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
    .replace(/\[\d+(?:\s*,\s*\d+)*\]/g, "")
    .replace(/^\s{0,3}#{1,6}\s+/, "")
    .replace(/^\s*(?:[-*+]|\d+\.)\s+/, "")
    .replace(/(\*\*|__|`)/g, "")
    .replace(/\s{2,}/g, " ")
    .replace(/\s+([.,;:!?])/g, "$1")
    .trim();
}

/** An answer's markdown as plain sentences to read aloud: no tables, code, links, citations or markup. */
export function toSpokenText(markdown = "") {
  const text = markdown
    .replace(/```[\s\S]*?```/g, "\n")
    .split("\n")
    .filter((line) => !line.trim().startsWith("|"))
    .map(toSpokenLine)
    .filter(Boolean)
    // A heading or list item ends where its line does, so it is read as its own sentence.
    .map((line) => (/[.!?:;,]$/.test(line) ? line : `${line}.`))
    .join(" ");

  if (text.length <= MAX_SPOKEN_CHARS) {
    return text;
  }

  const cut = text.slice(0, MAX_SPOKEN_CHARS);
  const lastSentenceEnd = Math.max(cut.lastIndexOf(". "), cut.lastIndexOf("? "), cut.lastIndexOf("! "));
  const spoken = lastSentenceEnd > 0 ? cut.slice(0, lastSentenceEnd + 1) : `${cut.trim()}…`;

  return `${spoken} The rest is on screen.`;
}
